import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Fade, IconButton } from "@mui/material";
import styled from "@emotion/styled";
import { useEffect, useState } from "react";

const FloatingButton = styled(IconButton)`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 12px;
  background-color: ${(p) => p.theme.colors.background2};
  border: 1px solid ${(p) => p.theme.colors.border};
  border-radius: 50%;
  width: 40px;
  height: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition:
    opacity 0.2s ease,
    visibility 0.2s ease;

  &:hover {
    border: 1px solid ${(p) => p.theme.colors.border};
  }
`;

interface ScrollToBottomButtonProps {
  containerRef: React.RefObject<HTMLDivElement>;
  scrollThresholdPx?: number;
  hidden?: boolean;
  isReady?: boolean;
}

export const ScrollToBottomButton = ({
  containerRef,
  scrollThresholdPx = 600,
  hidden = false,
  isReady = true,
}: ScrollToBottomButtonProps) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const checkScroll = () => {
      const distanceFromBottom =
        container.scrollHeight - container.scrollTop - container.clientHeight;
      setShow(distanceFromBottom > scrollThresholdPx);
    };

    const resizeObserver = new ResizeObserver(checkScroll);
    resizeObserver.observe(container);
    container.addEventListener("scroll", checkScroll);
    checkScroll();

    return () => {
      container.removeEventListener("scroll", checkScroll);
      resizeObserver.disconnect();
    };
  }, [containerRef, scrollThresholdPx, isReady]);

  const scrollToBottom = () => {
    containerRef.current?.scrollTo({
      top: containerRef.current.scrollHeight,
      behavior: "smooth",
    });
  };

  return (
    <Fade in={show && !hidden}>
      <FloatingButton onClick={scrollToBottom} size="small">
        <KeyboardArrowDownIcon />
      </FloatingButton>
    </Fade>
  );
};
